(() => {
  const root = document.documentElement;
  if (root.hasAttribute('data-hsg-support-managed')) return;
  root.setAttribute('data-hsg-support-managed', '');
  const mobile = window.matchMedia('(max-width: 767px)');
  let bar;
  let resizeObserver;
  let stateObserver;
  let startupObserver;
  let startupTimeout;

  const updateOffset = () => {
    const visible = mobile.matches && bar?.isConnected && bar.dataset.position !== 'top' &&
      getComputedStyle(bar).visibility === 'visible';
    const height = visible ? Math.ceil(bar.getBoundingClientRect().height) : 0;
    const value = `${height}px`;
    if (root.style.getPropertyValue('--hsg-mobile-cart-height') !== value) {
      root.style.setProperty('--hsg-mobile-cart-height', value);
    }
  };
  const bindBar = () => {
    const next = document.querySelector('.template-product cart-bar');
    if (bar !== next) {
      resizeObserver?.disconnect();
      stateObserver?.disconnect();
      bar?.removeEventListener('focusin', updateOffset);
      bar?.removeEventListener('focusout', onBlur);
      bar?.removeEventListener('transitionend', updateOffset);
      bar = next;
      if (bar) {
        resizeObserver = new ResizeObserver(updateOffset);
        resizeObserver.observe(bar);
        stateObserver = new MutationObserver(updateOffset);
        stateObserver.observe(bar, { attributes: true, attributeFilter: ['class', 'data-position'] });
        bar.addEventListener('focusin', updateOffset);
        bar.addEventListener('focusout', onBlur);
        bar.addEventListener('transitionend', updateOffset);
      }
    }
    updateOffset();
  };
  const onBlur = () => requestAnimationFrame(updateOffset);
  const stopStartup = () => {
    startupObserver?.disconnect();
    clearTimeout(startupTimeout);
  };
  const attachLauncher = () => {
    const launcher = document.querySelector('.shp-cnv-shipway-chat');
    if (!launcher) return false;
    launcher.classList.add('hsg-mobile-support');
    if (!launcher.hasAttribute('aria-label')) launcher.setAttribute('aria-label', 'WhatsApp');
    stopStartup();
    return true;
  };
  const refresh = () => {
    bindBar();
    if (attachLauncher()) return;
    stopStartup();
    startupObserver = new MutationObserver(attachLauncher);
    startupObserver.observe(document.body, { childList: true, subtree: true });
    startupTimeout = setTimeout(stopStartup, 60000);
  };
  const suspend = () => {
    stopStartup();
    resizeObserver?.disconnect();
    stateObserver?.disconnect();
    bar?.removeEventListener('focusin', updateOffset);
    bar?.removeEventListener('focusout', onBlur);
    bar?.removeEventListener('transitionend', updateOffset);
    bar = null;
  };
  mobile.addEventListener('change', updateOffset);
  window.addEventListener('resize', updateOffset, { passive: true });
  window.addEventListener('pagehide', suspend);
  window.addEventListener('pageshow', refresh);
  document.addEventListener('theme:product-info:loaded', refresh);
  document.addEventListener('shopify:section:load', refresh);
  refresh();
})();
